export function AvailabilityTrackerPanel() {
  return <div style={{
    height: 'calc(100vh - 112px)'
  }} data-id="element-384" data-mp="22ndo5omahbi6">
      <iframe src="https://availability-tracker.com/" title="Availability Tracker" style={{
      width: '100%',
      height: '100%',
      border: 'none',
      display: 'block'
    }} allow="fullscreen" data-id="element-385" data-mp="3tex88rar5pha" />
    </div>;
}